import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../utils/baseQueryWithAuth';

// Types pour les équipes
export interface Team {
  team_id: number;
  salon: number;
  salon_info?: {
    salon_id: number;
    name: string;
    phone?: string;
    email?: string;
  };
  salon_name?: string;
  name: string;
  description?: string;
}

// Api RTK Query pour les équipes
export const teamsApi = createApi({
  reducerPath: 'teamsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Teams'],
  endpoints: (builder) => ({
    // Endpoint pour récupérer les équipes d'un salon spécifique
    salonTeams: builder.query<Team[], number>({
      query: (salonId) => ({
        url: `/api/teams/teams/salon_teams/`,
        params: { salon_id: salonId }
      }),
      providesTags: (result, error, salonId) => 
        result 
          ? [...result.map(({ team_id }) => ({ type: 'Teams' as const, id: team_id })), { type: 'Teams', id: `salon-${salonId}` }]
          : [{ type: 'Teams', id: `salon-${salonId}` }]
    }),
  }),
});

// Export des hooks générés automatiquement
export const {
  useSalonTeamsQuery,
} = teamsApi;
